class AboutSection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Si IntersectionObserver no es soportado, no hacemos nada.
    if (!('IntersectionObserver' in window)) {
      console.log("IntersectionObserver not supported");
      return;
    }

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1 // El elemento se considera visible cuando el 10% está en pantalla
    };

    const observerCallback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // Dejamos de observar una vez que es visible
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    // Aplicamos el observador solo a los elementos con la clase .scroll-animate dentro de esta sección
    const targets = this.querySelectorAll('.scroll-animate');
    targets.forEach(target => {
      observer.observe(target);
    });
  }
}

// Definimos el custom element para que el navegador lo reconozca
if (!customElements.get('about-section')) {
  customElements.define('about-section', AboutSection);
}